/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Main application javascript entry point.
// Order is significant: dependencies (e.g. jQuery) must be required before
// any plugin or legacy file that consumes them at import time.

// Third party dependencies, located in vendor/assets
require("javascripts/firebug/firebugx.js");
// jQuery 3.7.1 from npm does not auto-expose on window in a module context.
// Vendor plugins (icheck, fancybox, etc.) reference window.jQuery at runtime,
// so we must set it explicitly before any plugins load.
window.jQuery = window.$ = require("jquery");

require("javascripts/jquery_ujs.js");
require("javascripts/easing.js"); // jQuery plugin
// jQuery UI 1.14.1 from npm (modular imports, only what we use)
require("jquery-ui/ui/widgets/autocomplete"); // autocomplete + core, widget, position, keycode, menu
require("jquery-ui/ui/unique-id");
require("jquery-ui/ui/effect");
require("jquery-ui/ui/effects/effect-slide");

// Accessibility patch: jQuery UI 1.14.1 does not clear the live region when
// the autocomplete menu closes, leaving stale text for screen readers.
// Re-applies the fix from commit 8a743d82fb on the old vendor build.
$.widget("ui.autocomplete", $.ui.autocomplete, {
  _close: function(event) {
    this._super(event);
    this.liveRegion.text("");
  }
});
require("blueimp-file-upload"); // jQuery File Upload 10.32 from npm
require("javascripts/date.js"); // Modifies global Date
require("javascripts/date-en-AU.js"); // Plugin for above
require("javascripts/date-en-GB.js"); // Plugin for above
require("javascripts/fancybox.js"); // jQuery plugin
require("javascripts/icheck.min.js"); // jQuery plugin
require("javascripts/background-check.js"); // Doesn't need to be exposed

// Old IE polyfills
require("javascripts/es5-shim.js");
require("javascripts/es5-sham.js");
require("javascripts/polyfills/custom_event.js");

// Load some polyfills for older IEs
// Babel's polyfills
require("@babel/polyfill");
// and fetch
require("whatwg-fetch");

// Expose underscore as the global `_` for legacy code paths.
require("expose-loader?exposes=_!underscore");

// Expose moment-recur as the global `moment` for legacy code paths.
require("expose-loader?exposes=moment!moment-recur");

// Our primary javascript (app/assets/coffee/index.js manifest)

// Exposes namespace, Slzr exports as globals for legacy compatibility
//
// These are named exports from the lightbox module, hence the duplication of names
require("expose-loader?exposes=Slzr|Slzr,namespace|namespace!javascripts/coffee/base.js");

// Load shared analytics modules (self-initializing).
// Queue, Google Analytics, and Vitally initialize on import; providers subscribe on DOM ready.
require("./shared/analytics");

// Load the consent manager early, so it can be initialized for the rest of the JS
require("expose-loader?exposes=Slzr.ConsentManager!./cookie-consent-manager/api.js");
require("./cookie-consent-manager/index.js");
require("javascripts/coffee/onready.js");
require("javascripts/coffee/xhrfileupload.js");

// Load skip to main content JS file
require("./skip_to_main_content.js");

// Load custom elements
require("./custom-elements/index.js");

// Expose some globals from the lightbox and facebook modules
//
// These are named exports from the modules, hence the duplication of names
require("expose-loader?exposes=openIbox|openIbox,hideIbox|hideIbox,default_fancybox_options|default_fancybox_options!javascripts/coffee/lightbox.js");
require("expose-loader?exposes=postFBFeedItem|postFBFeedItem!javascripts/coffee/facebook.js");

// Require javascripts/coffee recursively
const legacyJavascripts = require.context("javascripts/coffee", true);
legacyJavascripts.keys().forEach(legacyJavascripts);

// Our JST templates
//
// The default export of the module is exposed as window.JST
require("expose-loader?exposes=JST!./jst-templates/index.js");

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)
